<template>
  <div class="mt-5 md:mt-0 container mx-auto pb-12 lg:pb-24">
    <!-- <Breadcrumb class="px-5 md:px-0 flex md:mt-6 text-primary-800" :items="items" /> -->

    <div class="mt-8 px-5 md:px-0 terms__grid grid gap-y-8 md:gap-y-16">
      <MainTitle el="h1" class="text-primary-A900 text-center text-1.6xl lg:text-2xl-1" align="left">
        <template #before>
          {{ $t('aboutUs') }}
        </template>
        {{ $t('us') }}
      </MainTitle>
      <div class="flex flex-col items-center md:flex-row md:items-start gap-14">
        <img src="/aboutUs.png" alt="" width="750" height="450" class="rounded-2xs" />
        <section v-purify="data?.data?.cmsPage?.content" class="text-primary-A900" />
      </div>

      <div class="">
        <MainTitle>
          <template #before>
            {{ $t('shopFrom') }}
          </template>
          {{ $t('title') }}
        </MainTitle>
        <ul class="[ grid grid-cols-2 gap-x-12 md:gap-x-22 gap-y-12 ] mt-12 lg:flex items-center justify-between">
          <li class="flex flex-col text-center items-center">
            <svg-icon name="graph/deals" width="40" height="40" class="mb-2" />
            <h3 class="text-primary-700 text-lg-1 font-bold">
              {{ $t('info1') }}
            </h3>
            <p class="text-secondary-700 text-base text-center">
              {{ $t('desc1') }}
            </p>
          </li>
          <li class="flex flex-col text-center items-center">
            <svg-icon name="graph/wallet" width="40" height="40" class="mb-2" />
            <h3 class="text-primary-700 text-lg-1 font-bold">
              {{ $t('info2') }}
            </h3>
            <p class="text-secondary-700 text-base text-center">
              {{ $t('desc2') }}
            </p>
          </li>
          <li class="flex flex-col text-center items-center">
            <svg-icon name="graph/wrench" width="40" height="40" class="mb-2" />
            <h3 class="text-primary-700 text-lg-1 font-bold">
              {{ $t('info3') }}
            </h3>
            <p class="text-secondary-700 text-base text-center">
              {{ $t('desc3') }}
            </p>
          </li>
          <li class="flex flex-col text-center items-center">
            <svg-icon name="graph/measurements" width="40" height="40" class="mb-2" />
            <h3 class="text-primary-700 text-lg-1 font-bold">
              {{ $t('info4') }}
            </h3>
            <p class="text-secondary-700 text-base text-center">
              {{ $t('desc4') }}
            </p>
          </li>
          <li class="flex flex-col text-center items-center">
            <svg-icon name="graph/payments" width="40" height="40" class="mb-2" />
            <h3 class="text-primary-700 text-lg-1 font-bold">
              {{ $t('info5') }}
            </h3>
            <p class="text-secondary-700 text-base text-center">
              {{ $t('desc5') }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t: $t, locale } = useI18n({ useScope: 'local' });
// const items = [
//   { label: t('home').toString(), path: '' },
//   { label: t('aboutUs').toString(), path: 'about' },
// ];

const { data } = useCmsPage('about-us-' + locale.value);

const { formatPageTitle } = useSeoFormatting();
useSeoMeta({
  title: formatPageTitle($t('aboutUs') as string),
});
</script>

<i18n>
{
  "en": {
    "home": "Home",
    "aboutUs": "About",
    "us": "Us",
    "title": "Miraco",
    "info1": "Exclusive Offers",
    "desc1": "Best Deals for Air Conditioners",
    "info2": "Free Shipping",
    "desc2": "Free delivery at your doorstep",
    "info3": "Free Installation",
    "desc3": "Free Installation when you shop online",
    "info4": "Find the Right Fit",
    "desc4": "Get the most compatible product for your room",
    "info5": "Payment Facilities",
    "desc5": "Pay in Cash, Credit or Debit Cards",
    "shopFrom": "Why Shop From"
  },
  "ar": {
    "home": "الرئيسية",
    "aboutUs": "من نحن",
    "title": "ميراكو",
    "info1": "عروض حصرية",
    "desc1": "أفضل عروض التكييفات",
    "info2": "شحن مجاني",
    "desc2": "توصيل مجاني حتى الباب",
    "info3": "تركيب مجاني",
    "desc3": "التركيب مجاني عندما تتسوق عبر الإنترنت",
    "info4": "اعثر على المنتج المناسب",
    "desc4": "احصل على أكثر المنتجات مناسبة لغرفتك",
    "info5": "تسهيلات الدفع",
    "desc5": "نقدًا عند الاستلام أو ببطاقة الائتمان أو الخصم",
    "shopFrom": "لماذا عليك الشراء من "
}
}
</i18n>
<style lang="postcss" scoped>
.terms__grid {
  @screen lg {
    @apply mx-auto;
    /* max-width: 650px; */
  }
}
</style>
